/* eslint-disable max-len */
import React from 'react';

export function RightArrow(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" fill="none" viewBox="0 0 15 14" {...props}>
      <path
        fill="#fff"
        d="M.992 6.995c0-.688.563-1.25 1.25-1.25h8.594L8.086 2.87c-.469-.5-.438-1.282.062-1.782a1.236 1.236 0 011.75.063l4.75 5c.47.469.47 1.25 0 1.719l-4.75 5c-.218.25-.562.375-.906.375a1.18 1.18 0 01-.844-.344 1.236 1.236 0 01-.062-1.75l2.75-2.906H2.242c-.687 0-1.25-.532-1.25-1.25z"
      ></path>
    </svg>
  );
}
